import React, { useState,useEffect } from "react";
import {useSelector,useDispatch} from 'react-redux';
import { getBedsByColorFilter } from "../../../../redux/actions/RatActions";
import { getCountOfFiltersInRat } from "../../../../redux/actions/GuestActions";
import { useNavigate } from "react-router-dom";
const Categories = ({
  filterItems,
  activeCategory,
  buildingId,
  year
}) => {
  const [wait, setWait] = useState(false);
  const data=useSelector((state)=>state.GuestInfo.guestFilterCount);
  const selectedOccupancyType=useSelector((state)=>state.GuestInfo.guestFilterCount);
  // console.log(data)
  const dispatch = useDispatch();
  useEffect(()=>{
  dispatch(getCountOfFiltersInRat(buildingId,selectedOccupancyType))
  },[])

  const navigate = useNavigate();
  return (
    <div>
      {(data && data.length>0) ?(data.map((category, index) => {
        return (
          <button
            type="button"
            className={`${
              activeCategory === category.id
                ? `filter-btn active ${category.category}`
                : `filter-btn ${category.category}`
            }`}
            key={index}
            onClick={() => {
              setWait(true);
              dispatch(getBedsByColorFilter(buildingId, category.type,year));
              filterItems(category.id);
              // props.getType(category.type)
            }}
          >
            <span>{category.title}  ({category.count})</span>
            {/* ({category.count}) */}
          </button>
         
        );
      })):(<div></div>)}
       {/* <button onClick={()=> {
         setTimeout(() => {
          navigate("/tracker");
        }, 4000);
       }}>Reset
        </button> */}
    </div>
  );
};
export default Categories;
